/** Broad-market + most-traded index ETFs surfaced by the "Index Funds Only"
 *  ticker-tape source (plan #227). Dan's pick anchored on SPY / TQQQ / SQQQ
 *  ("for sure"), padded out with the rest of the most-traded retail tickers:
 *  the major broad-market trackers, the popular 3× leveraged pairs, and
 *  the biggest sector SPDRs. Volatility ETFs (UVXY/VXX) live alongside
 *  because retail watches them as a fear gauge even though they're not
 *  strictly "index funds."
 *
 *  Keep this list short (< 25) — it's one of several tape sources and
 *  competes with Top Movers / Custom for the 50-row cap. */
export const INDEX_FUND_SYMBOLS: readonly string[] = [
  // Broad market
  'SPY', 'QQQ', 'IWM', 'DIA', 'VTI', 'VOO',
  // Leveraged broad / index
  'TQQQ', 'SQQQ', 'UPRO', 'SPXU',
  // Sector / popular
  'SOXL', 'SOXS', 'XLK', 'XLF', 'XLE',
  // Volatility (fear gauge — retail tracks alongside index funds)
  'UVXY', 'VXX',
] as const;
